/**
 * 记录 Object3D 子类是否已经进入销毁流程。
 *
 * Three r186 起 `Object3D.dispose()` 才会派发 `dispose` 事件，而 WebGL peer range 仍允许
 * `>=0.180.0`，旧 peer 的基类原型上并没有该方法。子类统一采用“首次进入才清理、并在基类方法
 * 存在时调用一次 `super.dispose()`”的语义：重复调用直接返回，既不重复释放几何体/材质，也不
 * 重复派发 `dispose` 事件。
 */
const disposedObjects = new WeakSet<object>()

/** 标记对象进入销毁流程；返回 `false` 表示此前已销毁，调用方应立即返回。 */
export function beginDisposeOnce(target: object): boolean {
  if (disposedObjects.has(target)) return false
  disposedObjects.add(target)
  return true
}
